enum Platform {
  Web = 1,
  Android = 2,
  iOS = 4
}

interface paymentMethod {
  name: string;
  methodId: number;
  enabledPlatform: Platform
}

function unavalaibleTips(platform: Platform) {
  const str = Object.values(Platform)
    .filter((p: string | number) => Number.isInteger(p))
    .map((p) => <number>p)
    .filter((p: number) => (platform & p) === 0)
    .map((p: number) => Platform[p])
    .join(', ');
  return str ? `(${str}不支援)` : '';
}

export const paymentMethodState = () => ({
  paymentMethods: [],
});

export const actions = {
  setPaymentMethod({ commit }: any, paymentMethods: paymentMethod[]) {
    const methods = paymentMethods.map(({ methodId, name, enabledPlatform }) => ({
      methodId,
      name: `${name}${unavalaibleTips(enabledPlatform)}`,
    }));
    commit('setPaymentMethod', methods);
  },
};

export const mutations = {
  setPaymentMethod(state: any, paymentMethods: paymentMethod[]) {
    state.paymentMethods = paymentMethods;
  },
};

export default {
  namespaced: true,
  state: paymentMethodState,
  actions,
  mutations,
};
